import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_SUBMIT_DOWNLOAD_JOB,
  FAILURE_SUBMIT_DOWNLOAD_JOB,
  LOADING_SUBMIT_DOWNLOAD_JOB,
  RESET_SUBMIT_DOWNLOAD_JOB,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
  error: null as string | null,
};

export const submitDownloadJobReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_SUBMIT_DOWNLOAD_JOB:
      return { ...state, loading: true, error: null, response: null };
    case SUCCESS_SUBMIT_DOWNLOAD_JOB:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_SUBMIT_DOWNLOAD_JOB:
      return { ...state, loading: false, error: action.payload };
    case RESET_SUBMIT_DOWNLOAD_JOB:
      return initialState;
    default:
      return state;
  }
};
